import React from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core';
import { IntegrationsMetaDataKeys, venueDetailsForm } from "../../../formSchemas/signup.form";
import DynamicForms from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import EColourPanel from "../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel";
import { setVenueData } from "../newVenue/state/newVenue.action";
import { useSignup } from "../state/SelfSignup";
import { IVenueData } from "../types";
import { ChevronRight } from "@material-ui/icons";
import { OnboardingSources } from "../types";
import { IntegrationsList } from "../../orders/constants";

const useStyles = makeStyles({
    leftButtonCustomClassName:{
        "@media(min-width: 425px)": {
            width:"unset",
            flexBasis:"unset",
            maxWidth:"unset",
            minHeight: "5rem",
            "& button":{
                right: "18rem",
                bottom: "2.1875rem",
                position: "absolute"
            },
        }
    },
    rightButtonCustomClassName:{
        "@media(min-width: 425px)": {
            width:"unset",
            flexBasis:"unset",
            maxWidth:"unset",
            "& button":{
                right: "3.75rem",
                bottom: "2.1875rem",
                position: "absolute"
            },
        }
    }
  });

export function handleIntegrationMetaData(data:any, host:string){
    if(IntegrationsList.includes(host as OnboardingSources)){
        // @ts-ignore
        const integrationKeys = IntegrationsMetaDataKeys[host];
        let apiData = {...data};
        apiData.metadata = {};
        integrationKeys.forEach((item:any)=>{
            apiData.metadata[item.key] = data[item.value];
            delete apiData[item.key]
        })
        return apiData;
    }
    return data
}

export function VenueDetailsForm() {
    const classes = useStyles();
    const { t } = useTranslation();
    const { goBack, dispatch, venueData, callLeadsAPI , host } = useSignup();
    function onSubmit(data: any) {
        const apiData = handleIntegrationMetaData(data, OnboardingSources[host]);
        const venueData = {
            venueDetails:apiData as IVenueData,
            onboarding_source:OnboardingSources[host]
        }
        dispatch(setVenueData(venueData));
        callLeadsAPI(apiData);

    }

    return <DynamicForms
        onHandleSubmit={onSubmit}
        formKeyName="register-venue-details"
        formRows={venueDetailsForm(t,host)}
        formData={venueData}
        formButtons={{
            leftButton: {
                type: 'button', label: "misc.back",
                onClick: goBack,
                color: EColourPanel.DEFAULT
            },
            rightButton: {
                type: 'submit', label: "signup.form.userDataButton",
                color: EColourPanel.PRIMARY, endIcon: <ChevronRight />,
            },
            leftButtonCustomClassName:classes.leftButtonCustomClassName,
            rightButtonCustomClassName:classes.rightButtonCustomClassName,
        }
        }
        useFormOptions={
            {
                reValidateMode: 'onBlur',
                mode: 'onBlur'
            }
        }
    />
}